// extracted by mini-css-extract-plugin
export default {"qualificationsbox":"Postjobs_qualificationsbox__5MCbL","insideboxqual":"Postjobs_insideboxqual__3Wmg3","insidelatime":"Postjobs_insidelatime__AYEKv"};